import React from 'react';
import { Input } from 'antd';

import { IFlowBaseInfoProps, IFormItemProps } from './typed';
import { validateMetricName } from 'emp-3.0/components/Metrics/IndividualMetric/MetricDetail';
import useFieldRequiredStatus from '@src/pages/workflow/hooks/useFieldRequiredStatus';
import CustomFormItem from '@src/emp-3.0/components/Metrics/IndividualMetric/MetricBuilder/CustomFormItem';
import { FoldIcon } from '../../components';
import { StyledLabel } from '@src/emp-3.0/components/Metrics/Flow/FlowForm/styled';
import { useIsPatternMode } from '@src/pages/metric-templates/utils';
import { LabelMultiSelect } from './components/TagSelectors';
const { TextArea } = Input;

const FormItem = ({ value, onChange, mode, type }: IFormItemProps) => {
  return mode === 'view' ? (
    <div>{value}</div>
  ) : type === 'textarea' ? (
    <TextArea
      style={{ maxWidth: 'calc(100% - 44px)' }}
      autoSize={{ minRows: 2, maxRows: 5 }}
      maxLength={500}
      value={value}
      onChange={(e) => {
        onChange?.(e);
      }}
    />
  ) : (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Input
        value={value}
        onChange={(e) => {
          onChange?.(e);
        }}
      />
      <FoldIcon />
    </div>
  );
};

const FlowBaseInfo: React.FC<IFlowBaseInfoProps> = ({ mode }) => {
  const { status, enableRequired } = useFieldRequiredStatus(['name']);
  const { isPatternMode } = useIsPatternMode();

  return (
    <>
      <CustomFormItem
        name="name"
        label={`${isPatternMode ? 'Pattern' : 'Flow'} Name`}
        labelAlign="left"
        validateStatus={status}
        rules={[
          { validator: (rule, value) => validateMetricName(rule, value, 'flow', enableRequired) },
        ]}
      >
        <FormItem mode={mode} />
      </CustomFormItem>
      <CustomFormItem
        name="description"
        label={
          <StyledLabel>
            <div>Description</div>
            <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontWeight: 400 }}>(Optional)</div>
          </StyledLabel>
        }
        labelAlign="left"
      >
        <FormItem mode={mode} type="textarea" />
      </CustomFormItem>
      {/* <CustomFormItem // TBD: Remove journey stage temporarily
        name="journey_stage"
        label={
          <StyledLabel>
            <div>Journey Stage</div>
            <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontWeight: 400 }}>(Optional)</div>
          </StyledLabel>
        }
        labelAlign="left"
      >
        <JourneyStageSelect />
      </CustomFormItem> */}
      <CustomFormItem
        name="labels"
        label={
          <StyledLabel>
            <div>Labels</div>
            <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontWeight: 400 }}>(Optional)</div>
          </StyledLabel>
        }
        labelAlign="left"
      >
        <LabelMultiSelect />
      </CustomFormItem>
    </>
  );
};

export default FlowBaseInfo;
